import { render, staticRenderFns } from "./SettingsNotificationSection.vue?vue&type=template&id=03b91c9d&scoped=true"
import script from "./SettingsNotificationSection.vue?vue&type=script&lang=js"
export * from "./SettingsNotificationSection.vue?vue&type=script&lang=js"
import style0 from "./SettingsNotificationSection.vue?vue&type=style&index=0&id=03b91c9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b91c9d",
  null
  
)

export default component.exports